export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgVGFyZ2V0ZWRVc2VyID0gewogIGVtYWlsOiBzdHJpbmc7CiAgY291bnQ6IG51bWJlcjsKfTsK"